import { render } from "./IconUpload.vue?vue&type=template&id=0e42a5a0"
const script = {}
script.render = render

export default script